import { Grid } from '@mui/material';
import { Acuity } from '../../../controls/agyle/ecds';
import { useTranslation } from 'react-i18next';

const ECDSAcuityControls = ({ value, onChange, canEdit, isError, startDate, noMargin }) => {
    const { t } = useTranslation();

    return (
        <Grid item xs={12} sx={{ my: noMargin ? 0 : 2 }}>
            <Acuity
                label={t('National Acuity Score')}
                color="primary"
                value={value?.discriminator}
                onChange={(_, value) => {
                    onChange((pr) => ({ ...pr, discriminator: value }));
                }}
                error={isError}
                disabled={!canEdit}
                admitDate={startDate}
                noBorder={false}
                withNewBackground
                size="large"
            />
        </Grid>
    );
};

export default ECDSAcuityControls;
